import { setToken } from "src/hooks/useGetGprocessToken";
import { UserType } from "../../auth/types/types";
import { RequestApiPrivate, gprocessApi } from "../component/api/axios";

export const generateGprocessToken = async (
  authUser: UserType,
  expiresAt: number,
  ssoAccessToken: string
) => {
  try {
    const json = {
      authUser,
      expired_in: expiresAt
    };
    const { data } = await gprocessApi.generateToken(json, ssoAccessToken);
    RequestApiPrivate.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${data.access_token}`;

    setToken(`Bearer ${data.access_token}`);
  } catch (error) {
    throw error;
  }
};
